import { format } from 'date-fns';
import type { WiFiEvent } from '../types';
import { tz } from '../utils/timezone';

interface Props {
  events: WiFiEvent[];
}

export function WiFiEventsCard({ events }: Props) {
  return (
    <div className="hud-card">
      <div className="hud-corner-tl" /><div className="hud-corner-tr" /><div className="hud-corner-bl" /><div className="hud-corner-br" />
      <div className="hud-card-header">
        <div className="flex items-center gap-2.5">
          <svg className="w-4 h-4 text-hud-green opacity-80" viewBox="0 0 16 16" fill="none">
            <path d="M2 6C4.5 3 11.5 3 14 6" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
            <path d="M4 9C5.8 7 10.2 7 12 9" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"/>
            <circle cx="8" cy="12" r="1.2" fill="currentColor"/>
          </svg>
          <span className="hud-card-title">WiFi Events</span>
        </div>
        <span className="hud-card-badge">3M</span>
      </div>
      <div className="hud-card-body">
        <div className="space-y-0">
          {events.map((event, idx) => (
            <div
              key={`${event.device}-${event.timestamp.getTime()}-${idx}`}
              className="flex items-center gap-3 py-2 border-b border-card-inner last:border-b-0"
            >
              <span
                className={`w-2 h-2 rounded-full flex-shrink-0 ${
                  event.event === 'wifi_connected'
                    ? 'bg-hud-green shadow-[0_0_6px_rgba(0,255,136,0.2)]'
                    : 'bg-hud-red shadow-[0_0_6px_rgba(255,51,85,0.2)]'
                }`}
              />
              <div className="flex-1 min-w-0">
                <div className="font-mono text-xs text-hud-white">{event.ssid}</div>
                <div className="font-mono text-[10px] text-[#4a6a7a]">
                  {event.device}
                  {event.ip && <> &middot; {event.ip}</>}
                </div>
              </div>
              <span className="font-mono text-[10px] text-[#3a5a6a] flex-shrink-0">
                {format(event.timestamp, 'MMM d HH:mm')} {tz}
              </span>
            </div>
          ))}

          {events.length === 0 && (
            <p className="font-mono text-sm text-[#3a5a6a] text-center py-8">No WiFi events</p>
          )}
        </div>
      </div>
    </div>
  );
}
